import { Link } from 'react-router-dom';
import styled from 'styled-components';
import '../../utils/style/serie.css';

const AuteurLink = styled(Link)`
    text-decoration: none;
    color: #000000;
`;

const DynamicAuteurLink = styled(AuteurLink)`
    &:hover {
        background: linear-gradient(104deg, rgba(130, 255, 173,0) 0.9%, rgba(130, 255, 173,1.25) 2.4%, rgba(130, 255, 173,0.5) 5.8%, rgba(130, 255, 173,0.1) 93%, rgba(130, 255, 173,0.7) 96%, rgba(130, 255, 1732,0) 98%), linear-gradient(183deg, rgba(130, 255, 173,0) 0%, rgba(130, 255, 173,0.3) 7.9%, rgba(130, 255, 173,0) 15%);
        -webkit-box-decoration-break: clone;
        margin: 0;
        border-radius: 7.5px;
        text-shadow: -12px 12px 9.8px rgba(130, 255, 173,0.7), 21px -18.1px 7.3px rgba(255, 255, 255,1), -18.1px -27.3px 30px rgba(255, 255, 255,1);
        text-decoration: none;
    }
`;

// Affichage lecture seule d'un auteur : lien vers la recherche par nom.
// L'édition des auteurs d'un album passe désormais par AuteursEditor (mode édition).
function Auteur({ auteur }) {
    return (
        <DynamicAuteurLink to={'../search/' + auteur.nom}>
            {auteur.nom}
        </DynamicAuteurLink>
    )
}

export default Auteur
